import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PortalState, PortalStateService } from '../../../services/portal-state.service';

export interface BreadcrumbItem {
  /** Translation key (static labels) */
  labelKey?: string;
  /** Plain text (data such as service definition / environment names) */
  label?: string;
  /** Navigates back to this level; absent for the current (last) item */
  navigate?: () => void;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: false
})
export class BreadcrumbComponent {
  items$: Observable<BreadcrumbItem[]>;

  constructor(private portalStateService: PortalStateService) {
    this.items$ = this.portalStateService.getCurrentState().pipe(
      map(state => this.buildItems(state))
    );
  }

  private buildItems(state: PortalState): BreadcrumbItem[] {
    const items: BreadcrumbItem[] = [{
      labelKey: 'FEATURES.BREADCRUMB.HOME',
      navigate: () => this.portalStateService.goHome()
    }];

    if (state.currentView === 'faq') {
      items.push({ labelKey: 'FEATURES.BREADCRUMB.FAQ' });
    }

    if (state.serviceId) {
      const { serviceId, serviceName, blueprintId } = state;
      items.push({
        label: serviceName,
        navigate: () => this.portalStateService.viewServiceDetails(serviceId, serviceName, blueprintId)
      });
    }

    if (state.envId) {
      const { envId, envName } = state;
      items.push({
        label: envName,
        navigate: () => this.portalStateService.viewEnvironment(envId, envName)
      });
    }

    // The last item is the current page, so it is not clickable
    delete items[items.length - 1].navigate;
    return items;
  }
}
